import React from 'react';

import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 2,
    gap: theme.utils.spacing('ref/spacing/2'),
    paddingTop: theme.utils.spacing('ref/spacing/2'),
    paddingInline: theme.utils.spacing('ref/spacing/1'),
  },

  headerRow: {
    display: 'grid',
    gridTemplateColumns: '1fr min-content',
    columnGap: theme.utils.spacing('ref/spacing/3'),
    overflow: 'hidden',
    flexShrink: 0,
  },

  header: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },

  bottom: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.utils.spacing('ref/spacing/2'),
    marginTop: 'auto',
    flexShrink: 0,
  },

  main: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.utils.spacing('ref/spacing/2'),
  },

  footer: {
    paddingInline: 0,
  },
}));

export const ListingCardDetails = ({
  slots,
  children,
}: {
  slots: {
    corner: React.ReactNode;
    header: React.ReactNode;
    footer: React.ReactNode;
  };
  children: React.ReactNode;
}) => {
  const { classes } = useStyles();

  return (
    <div className={classes.container}>
      <div className={classes.headerRow}>
        <div className={classes.header}>{slots.header}</div>
        <div>{slots.corner}</div>
      </div>

      <div className={classes.bottom}>
        <div className={classes.main}>{children}</div>
        <div className={classes.footer}>{slots.footer}</div>
      </div>
    </div>
  );
};
